import React from 'react';
import { Skeleton, Row, Col } from 'antd';

/**
 * BatchLoadingSkeleton - Loading skeleton for batch list
 */
const BatchLoadingSkeleton = () => {
  return (
    <Row gutter={[16, 16]}>
      {Array.from({ length: 6 }).map((_, i) => (
        <Col xs={24} sm={12} md={8} lg={6} key={i}>
          <Skeleton
            active
            avatar={false}
            title={false}
            paragraph={{
              rows: 3,
              width: ['100%', '80%', '60%'],
            }}
            style={{
              padding: '16px',
              borderRadius: '8px',
            }}
          />
        </Col>
      ))}
    </Row>
  );
};

export default BatchLoadingSkeleton;

